// src/constants/urls.js

const isDevelopment = process.env.NODE_ENV === "development";
const DEV_API_BASE = "http://10.98.15.79:9395";

const getUrl = (path) => (isDevelopment ? `${DEV_API_BASE}${path}` : path);

export const CAPTCHA_URL = getUrl("/regform/captcha");
export const DRAFT_LIST_FORM_URL = getUrl("/regform/draft/list");
export const DRAFT_LOAD_FORM_URL = getUrl("/regform/draft/load");
export const DRAFT_SAVE_URL = getUrl("/regform/draft/save");
export const DRAFT_DELETE_URL = getUrl("/regform/draft/delete");
export const SUBMISSION_URL = getUrl("/regform/submit");
